import appConfig from '@src/app.config.ES6';

export const kitchenDrawerNavItemMixin = {
  data() {
    return {
      navItems: [],
    };
  },
  methods: {
    getDrawerNavItems() {
      return this.navItems;
    },
  },
  mounted() {
    this.navItems.push({
      title: 'Favorites',
      langTitle: this.$t('lblFavorites'),
      component: 'Favorites',
      icon: 'icon-heart',
    });

    this.navItems.push({
      title: 'All Recipes',
      langTitle: this.$t('recipes.title'),
      component: 'Recipes',
      icon: 'icon-recipes',
    });

    if (appConfig.PLANS_ENABLED) {
      this.navItems.push({
        title: 'Plans',
        langTitle: this.$t('lblPlans'),
        component: 'Plans',
        icon: 'icon-chef-hat',
      });
    }

    if (appConfig.MACROS_ENABLED) {
      this.navItems.push({
        title: 'Macros',
        langTitle: this.$t('lblMacros'),
        component: 'MacroWizard',
        icon: 'icon-pie-chart',
      });
    }

    this.navItems.push({
      title: 'Grocery List',
      langTitle: this.$t('lblGroceryList'),
      component: 'GroceryList',
      icon: 'icon-grocery-basket',
    });

    this.navItems.push({
      title: 'Settings',
      langTitle: this.$t('lblSettings'),
      component: 'Settings',
      icon: 'icon-settings',
    });
  },
};
